



















































































import { Component, Vue, Prop } from "vue-property-decorator";
import Dianquan from "./dianquan.vue";
import { getBiduiZygczb } from "@/request/idr";
@Component({
  components: {
    Dianquan
  }
})
export default class IdrBiduiZygczb extends Vue {
  @Prop()
  private tongues: any;
  private loaded: boolean = false;
  private message: any = {};
  private showPart: any = {
    first: {},
    second: {},
    third: {},
    forth: {},
    fifth: {}
  };
  private showPartTitle: any = {
    first: "舌色",
    second: "苔质"
  };
  private showPartFilter: any = {
    first: "全舌",
    second: "苔剥",
    fifth: "齿痕"
  };
  /**
   * @description 获取信息
   */
  private fetchMessage() {
    this.loaded = false;
    const ids: any[] = [];
    this.tongues.map((item: any) => {
      ids.push(item.tongue_id);
    });
    const params: any = {
      tongue_ids: ids
    };
    getBiduiZygczb(this, params).then((data: any) => {
      //   console.log(data);
      this.message = data;
      this.showPart.first = data["舌色"]["全舌"];
      this.showPart.second = data["苔质"]["苔剥"];
      this.showPart.third = data["舌形"]["舌胖瘦"];
      this.showPart.forth = data["舌形"]["老嫩"];
      this.showPart.fifth = data["舌形"]["齿痕"];
      this.loaded = true;
    });
  }
  /**
   * @description 切换第一部分的展示模块
   */
  private changeShowPartFirst(part) {
    this.showPartTitle.first = part;
    const keys: any = Object.keys(this.message[part]);
    this.showPart.first = this.message[part][keys[0]];
    this.showPartFilter.first = keys[0];
  }
  /**
   * @description 改变各部分的filter
   */
  private changeFilter(index, key) {
    this.showPartFilter[index] = key;
    this.showPart[index] = this.message[this.showPartTitle[index]][key];
  }
  /**
   * @description 改变第五部分的筛选
   */
  private changeFifthFilter(key) {
    this.showPartFilter.fifth = key;
    this.showPart.fifth = this.message["舌形"][key];
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.fetchMessage();
  }
}
